.element {
  position: relative;
  background: linear-gradient(112.83deg, rgba(53, 53, 53, 0.376) 0%, rgba(56, 59, 70, 0.8) 110.84%);
  border-radius: var(--border-radius-medium);
  backdrop-filter: blur(8px);
  padding: 1.6rem;
  width: 25rem;

  @media screen and (min-width: $bp-small) {
    width: 40rem;
  }

  &:last-of-type {
    margin-bottom: 0;
  }

  @keyframes animation {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}

.close-icon {
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
  cursor: pointer;

  svg {
    height: 1.4rem;
    width: 1.4rem;
    fill: white;
  }
}

.alert-content {
  display: flex;
  flex-direction: row;
  justify-content: start;
}

.alert-icon-type {
  svg {
    height: 1.8rem;
    width: 1.8rem;
  }
}

.alert-text {
  font-weight: 500;
  margin-bottom: 0.4rem;
}

.alert-information {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 1.6rem;
}

.time-box {
  font-size: 1.2rem;
  opacity: 0.6;
}
